import { FormInputMoney, FormInputNumber } from "@farzoom/common-ui-components";
import { Space } from "antd";
import { useFormContext } from "react-hook-form";
import { useStyles } from "./styles";

type Props = {prefix: string;};

export const CustomerStaff = ({
  prefix,
}: Props) => {
  const { control, setValue, register, getValues } = useFormContext();
  const classes = useStyles();
  const initialValues = getValues("customerStaff.staff");

  return (
    <fieldset>
      <div className={classes.title}>Сведения о персонале</div>
      <div className={classes.wrapper}>
        <Space>
          <FormInputNumber
            label="Штат сотрудников, чел"
            name={`${prefix}.staff.staffCount`}
            control={control}
            setValue={setValue}
            register={register}
            defaultValue={initialValues?.staffCount}
            controls={false}
            min={0}
            // disabled={config.readonly}
          />
          <FormInputMoney
            label="Фонд оплаты в год, руб"
            name={`${prefix}.staff.staffWageFund`}
            control={control}
            setValue={setValue}
            register={register}
            defaultValue={initialValues?.staffWageFund}
            controls={false}
            min={0}
            maxLength={25}
            // disabled={config.readonly}
          />
          <FormInputMoney
            label="Задолженность по ЗП, руб"
            name={`${prefix}.staff.staffWageDebt`}
            control={control}
            setValue={setValue}
            register={register}
            defaultValue={initialValues?.staffWageDebt}
            controls={false}
            min={0}
            // disabled={config.readonly}
          />
        </Space>
      </div>
    </fieldset>
  );
};
